import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface SimpleLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
}

export const SimpleLayout: React.FC<SimpleLayoutProps> = ({
  children,
  pageTitle
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sigma-grey via-white to-sigma-grey">
      <Header />
      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default SimpleLayout;